import React, { useState } from "react";
import bgr from "./gdfdsfgjgfh.jpg";

function Filtercategoryitem({ start }) {
  let [activefilter, setactivefilter] = useState(false);
  return (
    <div
      className={`FilterCategory-container active ${
        activefilter ? "active" : ""
      }`}
      onClick={() => setactivefilter(true)}
    >
      <div className="filter-image">
        <img src={bgr} alt="" />
      </div>
      <span>{start}</span>
    </div>
  );
}

export default Filtercategoryitem;
